import React from "react";
import { useNotification } from "./useNotification";
import { NotificationItem } from "./NotificationItem";
import styles from "./Notification.module.scss";
import { useSelector } from "react-redux";
import {
  selectNotificationLoading,
  selectNotifications,
} from "Redux/Notifications/slice";
import classNames from "classnames";
import Button from "Components/UI/Button/Button";
import { useAppDispatch } from "Redux/store";
import { getNotificationsMore } from "Redux/Notifications/reducer";
import { NOTIFICATIONS_LIMIT } from "Shared/Constants/app";
import SkeletonLoader from "Components/SkeletonLoader/SkeletonLoader";

type Props = {
  onClose: () => void;
};

export default function NotificationsList({ onClose }: Props) {
  const dispatch = useAppDispatch();
  const { notificationsList, dateRange } = useNotification();
  const notifications = useSelector(selectNotifications);
  const isLoading = useSelector(selectNotificationLoading);

  const handleLoadMore = () => {
    dispatch(
      getNotificationsMore({
        limit: NOTIFICATIONS_LIMIT,
        offset: notifications.results.length,

        created_after: dateRange.created_after,
        created_before: dateRange.created_before,
      })
    );
  };

  if (!isLoading && !notificationsList.length) {
    return <p className={styles.empty}>There are no notifications yet</p>;
  }

  if (!notifications.count && isLoading) {
    return (
      <SkeletonLoader
        variant="list"
        height="60px"
        amountOfBlocks={12}
        spacing={4}
      />
    );
  }

  return (
    <div>
      <div>
        {notificationsList.map((item) => (
          <div key={item.day.number} className={styles.date}>
            <div className={styles.title}>
              <span />
              <p>{item.day.title}</p>
              <span />
            </div>
            <div>
              {item.list.map((el) => (
                <div key={el.app_name} className={styles.notificationContent}>
                  {!!el.app_name && (
                    <p
                      className={classNames(
                        styles.title,
                        el.list.every((e) => e.is_read) && styles.title_read
                      )}
                    >
                      {el.app_name.split("_").join(" ")}:
                    </p>
                  )}
                  {el.list.map((elem) => (
                    <NotificationItem
                      onClose={onClose}
                      key={elem.id}
                      notification={elem}
                    />
                  ))}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      {isLoading ? (
        <SkeletonLoader
          variant="list"
          height="60px"
          amountOfBlocks={6}
          spacing={4}
        />
      ) : (
        !!notifications.next && (
          <div className={styles.loadMore}>
            <Button fullWidth onClick={handleLoadMore}>
              Load more
            </Button>
          </div>
        )
      )}
    </div>
  );
}
